import {
  Sale,
  SaleCreate,
  SaleUpdate,
  DbSale,
  DbSaleInsert,
  DbSaleUpdate,
  SaleItem,
  DbSaleItemInsert,
} from '@/types/entities/sale';

// Database -> Frontend
export function dbSaleToSale(db: DbSale): Sale {
  return {
    id: db.id,
    userId: db.user_id,
    clientId: db.client_id ?? undefined,
    paymentMethodId: db.payment_method_id ?? undefined,
    paymentStatusId: db.payment_status_id ?? undefined,
    totalAmount: db.total_amount,
    paidAmount: db.paid_amount,
    notes: db.notes ?? undefined,
    rentalPointId: db.rental_point_id ?? undefined,
    createdAt: new Date(db.created_at),
    updatedAt: new Date(db.updated_at),
  };
}

// Frontend -> Database
export function saleCreateToDbInsert(input: SaleCreate, currentUserId: string): DbSaleInsert {
  return {
    user_id: currentUserId,
    client_id: input.clientId ?? null,
    payment_method_id: input.paymentMethodId ?? null,
    payment_status_id: input.paymentStatusId ?? null,
    total_amount: input.totalAmount,
    paid_amount: input.paidAmount,
    notes: input.notes ?? null,
    rental_point_id: input.rentalPointId ?? null,
  };
}

export function saleUpdateToDbUpdate(input: SaleUpdate): DbSaleUpdate {
  const out: DbSaleUpdate = {};
  if (input.clientId !== undefined) out.client_id = input.clientId ?? null;
  if (input.paymentMethodId !== undefined) out.payment_method_id = input.paymentMethodId ?? null;
  if (input.paymentStatusId !== undefined) out.payment_status_id = input.paymentStatusId ?? null;
  if (input.totalAmount !== undefined) out.total_amount = input.totalAmount;
  if (input.paidAmount !== undefined) out.paid_amount = input.paidAmount;
  if (input.notes !== undefined) out.notes = input.notes ?? null;
  if (input.rentalPointId !== undefined) out.rental_point_id = input.rentalPointId ?? null;
  return out;
}

export function mapSaleItemsToDbInserts(saleId: string, items: SaleItem[] | undefined): DbSaleItemInsert[] {
  if (!items || items.length === 0) return [];
  return items.map((it) => ({
    sale_id: saleId,
    name: it.name,
    quantity: it.quantity,
    unit_price: it.price ?? null,
    total_price: it.total ?? null,
    store_product_id: it.storeProductId ?? null,
    inventory_item_id: it.inventoryItemId ?? null,
  }));
}
